import { BaseApi } from "../base.js";
import { API } from "../constants.js";
export class GiftCardsApi extends BaseApi {
  async getCards() {
    try {
      const request = await this.r.get(`${API.EMCD_GIFT_CARDS}/items`);
      return request.data;
    } catch (error) {
      throw new Error(error, "getCards error");
    }
  }

  async getCurrentOrderInfo(orderId) {
    try {
      const request = await this.r.get(
        `${API.EMCD_GIFT_CARDS}/user/orders/${orderId}/status`,
      );
      return request.data;
    } catch (error) {
      throw new Error(error, "getCurrentOrderInfo error");
    }
  }

  async getOrders() {
    try {
      const request = await this.r.get(`${API.EMCD_GIFT_CARDS}/user/orders`);
      return request.data;
    } catch (error) {
      throw new Error(error, "getOrders error");
    }
  }

  async purchaseOrder({ orderId, request_id }) {
    try {
      const request = await this.r.post(
        `${API.EMCD_GIFT_CARDS}/items/${orderId}/purchase?request_id=${request_id}`,
      );
      if (request.error === "Item is out of stock") {
        return request.error;
      }
      return request.data;
    } catch (error) {
      throw new Error(error, "purchaseOrder error");
    }
  }
}
